import React, { Component } from 'react';

import { spaceAndCapitalize } from '../../utilities/Forms.js'

class RadialMenu extends Component {
  renderName(option, index) {
    if (!this.props.override) {
      return spaceAndCapitalize(option)
    }

    return this.props.override[index] || spaceAndCapitalize(option)
  }

  render() {
    return (
      <div className="radial-menu" style={{ gridTemplateColumns: this.props.options.map(option => "1fr").join(" ") }}>
        {this.props.options.map((option, index) => (
          <div className="radial-option" key={option}>
            <input className="column" type="radio" name={this.props.name} id={option} value={option} checked={this.props.state === option} onChange={this.props.onChange} />
            <label htmlFor={option}>{this.renderName(option, index)}</label>
          </div>
        ))}
      </div>
    )
  }
}


export default RadialMenu;
